var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page gc" }, [
    _c("div", { staticClass: "container g9" }, [
      _c("div", { staticClass: "inner" }, [
        _c("h1", [_vm._v("Forgot your password?")]),
        _vm._v(" "),
        _c("h3", [
          _vm._v("Enter your e-mail address and we'll get you back on track."),
        ]),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { action: "#", method: "post", id: "form" },
            on: { submit: _vm.onSubmit },
          },
          [
            _c(
              "div",
              {
                ref: "email",
                staticClass: "input",
                class: { error: _vm.emailError },
                attrs: { type: "email" },
              },
              [
                _c("label", [
                  _c("span", [_vm._v("E-mail address")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email",
                      },
                    ],
                    attrs: {
                      type: "email",
                      placeholder: "E-mail",
                      tabindex: "1",
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      },
                    },
                  }),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("button", { class: { loading: _vm.isLoading } }, [
              _vm._v("Request reset link"),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Sply Tech ApS - All Rights Reserved")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }